<template>
	<auth-shell>
		<template v-if="!info">
			<h1 class="auth-title">Create your account</h1>
			<p class="auth-subtitle">Join Mission Control to manage municipalities, campaigns and clients.</p>

			<form @submit.prevent="register">
				<div class="auth-field">
					<label class="auth-label" for="name">Name</label>
					<div class="auth-input-group">
						<font-awesome-icon class="auth-input-icon" :icon="['fas', 'user']" />
						<input id="name" type="text" class="auth-input" placeholder="Your full name" autocomplete="name" v-model="user.name" />
					</div>
				</div>

				<div class="auth-field">
					<label class="auth-label" for="email">Email</label>
					<div class="auth-input-group">
						<font-awesome-icon class="auth-input-icon" :icon="['fas', 'envelope']" />
						<input id="email" type="email" class="auth-input" placeholder="you@townweb.com,you@heygov.com" autocomplete="email" v-model="user.email" required />
					</div>
				</div>

				<div class="auth-field">
					<label class="auth-label" for="password">Password</label>
					<div class="auth-input-group">
						<font-awesome-icon class="auth-input-icon" :icon="['fas', 'lock']" />
						<input
							id="password"
							:type="showPassword ? 'text' : 'password'"
							class="auth-input auth-input--has-toggle"
							placeholder="Create a password"
							autocomplete="new-password"
							minlength="6"
							v-model="user.password"
							required
						/>
						<button type="button" class="auth-input-toggle" :aria-label="showPassword ? 'Hide password' : 'Show password'" @click="showPassword = !showPassword">
							<font-awesome-icon :icon="['fas', showPassword ? 'eye-slash' : 'eye']" />
						</button>
					</div>
				</div>

				<div class="auth-field">
					<label class="auth-label" for="passwordConfirmation">Confirm password</label>
					<div class="auth-input-group">
						<font-awesome-icon class="auth-input-icon" :icon="['fas', 'lock']" />
						<input
							id="passwordConfirmation"
							:type="showConfirm ? 'text' : 'password'"
							class="auth-input auth-input--has-toggle"
							placeholder="Re-enter your password"
							autocomplete="new-password"
							minlength="6"
							v-model="user.password_confirmation"
							required
						/>
						<button type="button" class="auth-input-toggle" :aria-label="showConfirm ? 'Hide password' : 'Show password'" @click="showConfirm = !showConfirm">
							<font-awesome-icon :icon="['fas', showConfirm ? 'eye-slash' : 'eye']" />
						</button>
					</div>
				</div>

				<button v-if="!loading" type="submit" class="auth-btn">
					Create account
					<font-awesome-icon :icon="['fas', 'arrow-right']" />
				</button>
				<button v-else type="button" class="auth-btn" disabled>
					<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
					Creating account…
				</button>
			</form>

			<div class="auth-switch">
				Already have an account?
				<router-link class="auth-link" to="/login">Sign in</router-link>
			</div>
		</template>

		<div v-else class="auth-success">
			<div class="auth-success__icon"><font-awesome-icon :icon="['fas', 'check-circle']" /></div>
			<h1 class="auth-title">Account created</h1>
			<p class="auth-subtitle">Your account is ready. You can now sign in.</p>
			<router-link class="auth-btn" to="/login" style="text-decoration:none">
				Continue to sign in
				<font-awesome-icon :icon="['fas', 'arrow-right']" />
			</router-link>
		</div>
	</auth-shell>
</template>
<script>
import AuthShell from '../../components/auth/AuthShell.vue'
import restApi from '../../api'
import { handleErrors } from '../../actions/helpers.js'
export default {
	name: 'Register',
	components: { AuthShell },
	data() {
		return {
			user: {
				name: '',
				email: '',
				password: '',
				password_confirmation: '',
			},
			loading: false,
			info: '',
			showPassword: false,
			showConfirm: false,
		}
	},
	methods: {
		// Function to register user on system
		async register() {
			this.loading = true
			restApi
				.post(`/register`, this.user)
				.then(({ data }) => {
					this.info = data.message
					this.loading = false
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, 'register'),
						timer: 6000,
					})
					this.loading = false
				})
		},
	},
}
</script>
